<div class="topbar" [ngClass]="{ 'theme-dark': isDarkMode() }">
  <div class="search-section">
    <mat-form-field class="search-bar" appearance="outline">
      <mat-label>Port Name</mat-label>
      <input matInput [(ngModel)]="searchTerm" (input)="inputSearch()" />
      <mat-icon matSuffix *ngIf="searchTerm" (click)="clearSearch()" class="close-icon">close</mat-icon>
    </mat-form-field>
  </div>
  <button mat-raised-button color="primary" class="add-button" (click)="openAddPortDialog()">
    Add Port
  </button>
</div>

<div *ngIf="dataSource?.data as data">
  <ng-container *ngIf="data.length > 0; else noData">
    <div class="table-container" (scroll)="onManualScroll()">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" [ngClass]="{ 'dark-table': isDarkMode() }">

        <ng-container matColumnDef="Sl.No">
          <th mat-header-cell *matHeaderCellDef>Sl.No</th>
          <td mat-cell *matCellDef="let element; let i = index" style="text-align: center;">{{ i + 1 }}</td>
        </ng-container>
        <ng-container matColumnDef="country">
          <th mat-header-cell *matHeaderCellDef>Country</th>
          <td mat-cell *matCellDef="let element" style="text-align: left;">{{ element.country_name }}</td>
        </ng-container>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Port Name</th>
          <td mat-cell *matCellDef="let element" style="text-align: left;">{{ element.port_name }}</td>
        </ng-container>

        <!-- <ng-container matColumnDef="vessel_fields">
          <th mat-header-cell *matHeaderCellDef>Additional Vessel Details</th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"><button
              style="border: 1px solid lightblue;" (click)="openViewFieldsDialog(element)">View Fields</button></td>
        </ng-container> -->
        <!-- Action Column in port.component.html -->
        <ng-container matColumnDef="Action">
          <th mat-header-cell *matHeaderCellDef>Action</th>
          <td mat-cell *matCellDef="let element">
            <!-- View Info -->
            <button class="edit-icon-button" mat-icon-button matTooltip="View more" (click)="openViewFieldsDialog(element)">
              <mat-icon fontSet="material-symbols-outlined">info</mat-icon>
            </button>
            
            <!-- Edit Port -->
            <button class="edit-icon-button" mat-icon-button matTooltip="Edit" (click)="openEditPortDialog(element)">
              <mat-icon>edit</mat-icon>
            </button>

            <!-- Upload Tariff Services Files -->
            <input 
              type="file" 
              #fileInput 
              multiple 
              style="display: none;" 
              (change)="onFilesSelected($event, element.port_id)" 
            />
            <button 
              class="edit-icon-button" 
              mat-icon-button 
              matTooltip="Upload Tariff Service Files" 
              (click)="fileInput.click()">
              <mat-icon>upload_file</mat-icon>
            </button>
            <!-- View Uploaded Tariff Files -->
            <button 
              class="edit-icon-button" 
              mat-icon-button 
              matTooltip="View Tariff Files" 
              (click)="openViewFilesDialog(element)">
              <mat-icon>folder_open</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

    </div>

  </ng-container>
</div>

<ng-template #noData>
  <div class="no-data-text">
    No data found.
  </div>
</ng-template>